import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ActivityTimeline = ({ activities }) => {
  const getActivityIcon = (type) => {
    const icons = {
      event: 'Calendar',
      marketplace: 'ShoppingBag',
      review: 'Star',
      spot: 'MapPin',
      carpool: 'Car'
    };
    return icons?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colors = {
      event: 'text-primary bg-primary/10',
      marketplace: 'text-secondary bg-secondary/10',
      review: 'text-accent bg-accent/10',
      spot: 'text-success bg-success/10',
      carpool: 'text-warning bg-warning/10'
    };
    return colors?.[type] || 'text-muted-foreground bg-muted';
  };

  return (
    <div className="bg-card rounded-xl shadow-organic p-4 md:p-6 lg:p-8">
      <h2 className="text-xl md:text-2xl font-bold text-foreground mb-4 md:mb-6 flex items-center gap-2">
        <Icon name="Activity" size={24} />
        Son Aktiviteler
      </h2>
      <div className="space-y-4 md:space-y-6">
        {activities?.map((activity, index) => (
          <div key={activity?.id} className="relative">
            {index !== activities?.length - 1 && (
              <div className="absolute left-4 md:left-5 top-10 bottom-0 w-0.5 bg-border" />
            )}
            
            <div className="flex gap-3 md:gap-4">
              <div className={`flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-full ${getActivityColor(activity?.type)} flex items-center justify-center relative z-10`}>
                <Icon name={getActivityIcon(activity?.type)} size={16} />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 mb-2">
                  <div className="min-w-0">
                    <h3 className="text-sm md:text-base font-semibold text-foreground mb-1">
                      {activity?.title}
                    </h3>
                    <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
                      {activity?.description}
                    </p>
                  </div>
                  <span className="text-xs md:text-sm text-muted-foreground whitespace-nowrap">
                    {activity?.timestamp}
                  </span>
                </div>

                {activity?.image && (
                  <div className="mt-2 rounded-lg overflow-hidden w-full max-w-xs">
                    <Image
                      src={activity?.image}
                      alt={activity?.imageAlt}
                      className="w-full h-32 md:h-40 object-cover"
                    />
                  </div>
                )}

                {activity?.metadata && (
                  <div className="flex flex-wrap gap-2 mt-2">
                    {activity?.metadata?.map((meta, idx) => (
                      <span
                        key={idx}
                        className="text-xs bg-muted text-muted-foreground px-2 py-1 rounded"
                      >
                        {meta}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityTimeline;